import React, { useContext } from 'react';
import { AuthContext } from '../components/auth/AuthProvider';
import '../styles/App.css';
import DashboardContent from '../components/content/DashboardContent';

const Dashboard = () => {
  const { user, isLoading, isAuthenticated } = useContext(AuthContext)

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (!isAuthenticated) {
    return (
      <div className='container container-page'>
        You have been logged out. Log in to continue.
      </div>
    );
  }

  return (
    <div className='container container-page'>
      <DashboardContent 
        user={user}
      />
    </div>
  );
}

export default Dashboard;